var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('vue-title', {
    attrs: {
      "title": "Parental Consent Required - MyWhoosh"
    }
  }), _c('section', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-12 col-md-offset-2"
  }, [_c('div', {
    staticClass: "login-box"
  }, [!_vm.emailSent ? _c('div', {
    staticClass: "parental-consent-form"
  }, [_c('h3', [_vm._v("Ask a Parent or Guardian for Help")]), _vm._m(0), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "lead"
  }, [_vm._v(" To continue, please enter your parent's email address ")]), _c('form', {
    staticClass: "mt-4",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitParentalConsent.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "parentEmail"
    }
  }, [_vm._v("Parent's email address")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.parentEmail,
      expression: "parentEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "parentEmail",
      "placeholder": "parent@example.com",
      "required": "",
      "disabled": _vm.isSubmitting
    },
    domProps: {
      "value": _vm.parentEmail
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.parentEmail = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-block",
    class: {
      'btn-disabled': !_vm.parentEmail || _vm.isSubmitting
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.parentEmail || _vm.isSubmitting
    }
  }, [_vm.isSubmitting ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Sending... ")]) : _c('span', [_vm._v("Submit")])])])])])])]) : _c('div', {
    staticClass: "email-sent-confirmation text-center"
  }, [_vm._m(1), _c('h3', [_vm._v("Email sent")]), _c('p', {
    staticClass: "lead"
  }, [_vm._v(" We've sent an email to your parent at "), _c('strong', {
    staticClass: "text-primary"
  }, [_vm._v(_vm._s(_vm.parentEmail))])]), _c('p', [_vm._v(" Once they click the link and verify your account, you can close this window and go to the "), _c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("login page")]), _vm._v(" to start using MyWhoosh. ")], 1), _c('div', {
    staticClass: "actions mt-4"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg mr-3",
    attrs: {
      "disabled": _vm.isSubmitting
    },
    on: {
      "click": _vm.editEmail
    }
  }, [_vm._v(" Edit email address ")]), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    class: {
      'btn-disabled': _vm.isSubmitting || _vm.resendDisabled
    },
    attrs: {
      "disabled": _vm.isSubmitting || _vm.resendDisabled
    },
    on: {
      "click": _vm.resendEmail
    }
  }, [_vm.isSubmitting ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Sending... ")]) : _vm.resendDisabled ? _c('span', [_vm._v(" Resend in " + _vm._s(_vm.formatTime(_vm.resendCountdown)) + " ")]) : _c('span', [_vm._v("Resend Link")])])])]), _vm.errorMessage ? _c('div', {
    staticClass: "alert alert-danger mt-3"
  }, [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]) : _vm._e()])])])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Important:")]), _vm._v(" You need to be above 18 years to create your own account. But don't worry! you can still play with your parent's consent. ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "success-icon mb-4"
  }, [_c('i', {
    staticClass: "fa fa-check-circle text-success",
    staticStyle: {
      "font-size": "64px"
    }
  })]);
}]

export { render, staticRenderFns }